/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Event_Group_Sync_Error_ToastInputs */

const en_event_group_sync_error_toast = /** @type {(inputs: Event_Group_Sync_Error_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`There was an error syncing changes. ${i?.error}`)
};

const fr_event_group_sync_error_toast = /** @type {(inputs: Event_Group_Sync_Error_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`There was an error syncing changes. ${i?.error}`)
};

const de_event_group_sync_error_toast = /** @type {(inputs: Event_Group_Sync_Error_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`There was an error syncing changes. ${i?.error}`)
};

const it_event_group_sync_error_toast = /** @type {(inputs: Event_Group_Sync_Error_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`There was an error syncing changes. ${i?.error}`)
};

const ru_event_group_sync_error_toast = /** @type {(inputs: Event_Group_Sync_Error_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`There was an error syncing changes. ${i?.error}`)
};

const es_event_group_sync_error_toast = /** @type {(inputs: Event_Group_Sync_Error_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`There was an error syncing changes. ${i?.error}`)
};

const zh_cn2_event_group_sync_error_toast = /** @type {(inputs: Event_Group_Sync_Error_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`There was an error syncing changes. ${i?.error}`)
};

const ja_event_group_sync_error_toast = /** @type {(inputs: Event_Group_Sync_Error_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`There was an error syncing changes. ${i?.error}`)
};

const hi_event_group_sync_error_toast = /** @type {(inputs: Event_Group_Sync_Error_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`There was an error syncing changes. ${i?.error}`)
};

const pt_pt2_event_group_sync_error_toast = /** @type {(inputs: Event_Group_Sync_Error_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`There was an error syncing changes. ${i?.error}`)
};

/**
* | output |
* | --- |
* | "There was an error syncing changes. {error}" |
*
* @param {Event_Group_Sync_Error_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_sync_error_toast = /** @type {((inputs: Event_Group_Sync_Error_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Sync_Error_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_group_sync_error_toast(inputs)
	if (locale === "de") return de_event_group_sync_error_toast(inputs)
	if (locale === "it") return it_event_group_sync_error_toast(inputs)
	if (locale === "ru") return ru_event_group_sync_error_toast(inputs)
	if (locale === "es") return es_event_group_sync_error_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_event_group_sync_error_toast(inputs)
	if (locale === "ja") return ja_event_group_sync_error_toast(inputs)
	if (locale === "hi") return hi_event_group_sync_error_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_event_group_sync_error_toast(inputs)
	return en_event_group_sync_error_toast(inputs)
});